import React from 'react';
import TaxTable from './TaxTable';
import { newRegimeSlabs, oldRegimeSlabs } from './constants';

const IncomeTaxTables = () => {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold mb-4 sm:mb-0 text-center">
        Income Tax Slab Rates
      </h2>
      <div className="flex justify-between sm:block">
        <TaxTable title="New Regime Slab Rates" slabs={newRegimeSlabs} />
        <TaxTable title="Old Regime Slab Rates" slabs={oldRegimeSlabs} />
      </div>
      <div className="flex justify-end">
        * Slab rates vary for resident senior and super senior citizens.
      </div>
    </div>
  );
};

export default IncomeTaxTables;
